













































import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class NotCert extends Vue {}
